import { defaultColors } from '../../Services/contexts/ServicesChartsDataContext';
import { currency } from '../../Util/currency';

const useDonutChart = ({ chartData, subtitles, colors, isMoney, series, percentage, labelsOutside = false }) => {
    const seriesData = subtitles.map((item) => {
        const data =
            chartData
                .filter((counter) => counter.description === item)
                ?.reduce((acc, curr) => acc + Number(curr.total || 0), 0) || 0;

        return data;
    });

    const total = seriesData.reduce((acc, curr) => acc + curr, 0);

    const chartConfig = {
        series: series ?? (seriesData || []),
        options: {
            chart: {
                type: 'donut',
                toolbar: {
                    show: true
                }
            },
            labels: subtitles || [],
            colors: defaultColors || [],
            legend: {
                show: true,
                position: 'bottom',
                labels: {
                    colors: '#000',
                    useSeriesColors: false
                },
                itemMargin: {
                    horizontal: 10,
                    vertical: 5
                },
                onItemHover: {
                    highlightDataSeries: false
                }
            },
            dataLabels: labelsOutside
                ? {
                      enabled: true,
                      style: {
                          colors: ['#333'],
                          fontSize: '12px'
                      },
                      dropShadow: { enabled: false },
                      formatter: (val) =>
                          `${Number(val || 0).toLocaleString('pt-BR', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                          })}%`
                  }
                : {
                      enabled: true,
                      style: {
                          colors: ['#ffffff'],
                          fontSize: '12px',
                      },
                      formatter: (val, opts) => {
                          return `${val ? Number(val).toFixed(2) : '0.00'}%`;
                      }
                  },
            plotOptions: {
                pie: labelsOutside
                    ? {
                          customScale: 0.75,
                          donut: { size: '65%' },
                          dataLabels: { offset: 40, minAngleToShowLabel: 10 }
                      }
                    : {
                          donut: {
                              size: '70%'
                          }
                      }
            },
            tooltip: {
                enabled: true,
                style: {
                    fontSize: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    fontFamily: 'Arial, sans-serif',
                    padding: '10px',
                    pointerEvents: 'auto',
                    zIndex: '1000'
                },
                y: {
                    formatter: (val) => {
                        if (percentage) {
                            return total > 0 ? `${((val / total) * 100).toFixed(2)}%` : '0.00%';
                        }
                        return isMoney
                            ?  currency.formatToBrCurrency(val)
                            : val !== undefined && val !== null
                            ? val.toLocaleString('pt-BR')
                            : 'N/A';
                    }
                },
                x: {
                    formatter: (val) => {
                        return val !== undefined ? val.toString() : 'N/A';
                    }
                }
            }
        }
    };
    return {
        chartConfig
    };
};

export default useDonutChart;
